/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { IconButton, Typography } from "@mui/material"
import { useState } from "react"
import { useDispatch } from "react-redux"
import { setIsRoadCurvaturePopupVisible } from "../../../../redux/ducks/User/slice"
import ArgosButton from "../../Buttons/ArgosButton"
import ArgosTextField from "../../Form/TextField/ArgosTextField"
import ArgosDialogHeader from "../ArgosDialogHeader"
import CloseIcon from '@mui/icons-material/Close';
import ArgosFlexbox from "../../Containers/ArgosFlexbox"

const RoadCurvaturePopup = (props:any) => {
    const [curvatureValues, setCurvatureValues] = useState(props?.value)
    const editAccess = props?.editAccess
    const dispatch = useDispatch()
    const onClickCancel = () => {
        dispatch(setIsRoadCurvaturePopupVisible(false))
    }
    const onClickSave = () => {
        props?.roadCurvatureChanges(curvatureValues)
        dispatch(setIsRoadCurvaturePopupVisible(false))
    }
    return (<>
            <div style={{ display: 'flex', flexDirection: 'column'}}>
                <div>
                    <ArgosDialogHeader>
                        <ArgosFlexbox style={{justifyContent: 'space-between', alignItems: 'center'}}>
                            <Typography sx={{ color: 'white', fontSize: 14 }}>Road Curvature Values</Typography>
                            <IconButton onClick={onClickCancel} sx={{color: 'white', padding: 0, fontSize: 'small'}}> 
                                <CloseIcon />
                            </IconButton>
                        </ArgosFlexbox>
                    </ArgosDialogHeader>
                </div>
                {editAccess && <ArgosTextField 
                    style={{padding:'10px'}}
                    value={curvatureValues}
                    multiline={true}
                    onChange={(e) => setCurvatureValues(e.target.value)}
                />}
                {!editAccess && <ArgosTextField 
                    style={{padding:'10px'}}
                    value={curvatureValues}
                    multiline={true}
                />}
                
            </div>
            <div style={{marginBottom: 10, display: 'flex', justifyContent: 'center', gap: 10, justifySelf: 'flex-end'}}>
                <ArgosButton onClick={onClickCancel}>Cancel</ArgosButton>
                {editAccess && <ArgosButton onClick={onClickSave}>Save</ArgosButton>}
                {!editAccess && <ArgosButton onClick={onClickSave} disabled={true}>Save</ArgosButton>}              
            </div>
    </>
    )
}
export default RoadCurvaturePopup;